import * as React from 'react';
import { AppContext, IAppContext, IFormStateBase } from '../Types/Intyg.types';
import Personuppgifter from '../FormSections/Personuppgifter';
import Heading from '../FormSections/Heading';
import Adressuppgifter from '../FormSections/Adressuppgifter';
import TaEmotIntyget from '../FormSections/TaEmotIntyget';
import FormDivider from '../FormSections/FormDivider';
import MainBody from '../FormSections/MainBody';
import SubmitButton from '../FormSections/SubmitButton';
import { FormBase } from '../Types/FormBase';
import { Section, ApplicationType } from '../Types/Intyg.enums';
import Villkor from '../FormSections/Villkor';
import DeleteAnsokan from '../FormSections/DeleteAnsokan';

export interface IKontaktlinsbehorighetProps {}

export interface IKontaktlinsbehorighetState extends IFormStateBase {}

export default class Kontaktlinsbehorighet extends FormBase<IKontaktlinsbehorighetProps, IKontaktlinsbehorighetState> {
  constructor(props: IKontaktlinsbehorighetProps) {
    super(props);

    this.state = { isFormValid: false };
  }

  static contextType = AppContext;

  public render() {
    const appContext = this.context as IAppContext;

    return (
      <>
        <Heading />
        <MainBody />
        <TaEmotIntyget ref={this.sectionRefMap.get(Section.TaEmotIntyget) as React.RefObject<TaEmotIntyget>} />
        <FormDivider />
        <Personuppgifter ref={this.sectionRefMap.get(Section.Personuppgifter) as React.RefObject<Personuppgifter>} />
        <FormDivider />
        {appContext.model.skickaPost && (
          <>
            <Adressuppgifter
              ref={this.sectionRefMap.get(Section.Adressuppgifter) as React.RefObject<Adressuppgifter>}
            />
            <FormDivider />
          </>
        )}
        {<Villkor ref={this.sectionRefMap.get(Section.Villkor) as React.RefObject<Villkor>} />}
        <SubmitButton isEnabled={this.state.isFormValid} />
        <FormDivider />
        {appContext.applicationType === ApplicationType.Eservice && <DeleteAnsokan />}
        {appContext.model.skickaPdf && (
          <input type="hidden" name="lang_checkbox" value={appContext.Translate('svenska')} />
        )}
      </>
    );
  }
}
